import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import {
	DirectAssignRequest,
	QuoteSupplierItemPartRequest,
	QuoteSupplierItemSaveCartRequest,
	QuoteSupplierItemUpdateQuantityRequest,
	QuoteSupplierItemUploadImageRequest,
	QuoteSupplierRemoveCartRequest,
} from "@/main/models/request";
import {
	QuoteSupplierItemPartResponse,
	QuoteSupplierItemResponse,
	QuoteSupplierItemSaveCartResponse,
	SaveQuoteSupplierItemImageResponse,
	SearchNAGSCodeResponse,
} from "@/main/models/response";

export abstract class IQuoteSupplierItemApi {
	abstract saveCart(
		request: QuoteSupplierItemSaveCartRequest,
	): Promise<AxiosResponse<Result<QuoteSupplierItemSaveCartResponse>>>;
	abstract deleteCart(
		request: QuoteSupplierRemoveCartRequest,
	): Promise<AxiosResponse<Result<QuoteSupplierItemSaveCartResponse>>>;

	abstract getParts(
		request: QuoteSupplierItemPartRequest,
	): Promise<AxiosResponse<Result<QuoteSupplierItemPartResponse[]>>>;
	abstract searchNAGSCode(guidQuote: string): Promise<AxiosResponse<Result<SearchNAGSCodeResponse>>>;
	abstract save(request: QuoteSupplierItemPartRequest[]): Promise<AxiosResponse<Result<any>>>;
	abstract updatequantitypart(
		request: QuoteSupplierItemUpdateQuantityRequest,
	): Promise<AxiosResponse<Result<QuoteSupplierItemPartResponse>>>;
	abstract clearAllCart(guidQuote: string): Promise<AxiosResponse<Result<any>, any>>;
	abstract saveBuyerPartAsnwer(request: DirectAssignRequest): Promise<AxiosResponse<Result<QuoteSupplierItemResponse>>>;
	abstract saveBuyerPartAsnwerClaim(
		request: DirectAssignRequest,
	): Promise<AxiosResponse<Result<QuoteSupplierItemResponse>>>;
	abstract uploadImage(
		request: QuoteSupplierItemUploadImageRequest,
	): Promise<AxiosResponse<Result<SaveQuoteSupplierItemImageResponse>>>;
	abstract deleteImage(guids: string[]): Promise<AxiosResponse<Result<unknown>>>;
}
